import React, { useEffect } from 'react';
import SelectClient from './style';
import { useDispatch, useSelector } from 'react-redux';
import { SearchClientsProjectsAction } from '../../../redux/actions/clientsProjects';

export default function SelectClientSincroniza({ setCnpj, setClientAndProject, setCompany }) {
  const { userInfo } = useSelector((state) => state.userSign);
  const { clientsProjects: searchClientsProjects, error: searchClientsProjectsError } = useSelector(
    (state) => state.searchClientsProjects,
  );
  const dispatch = useDispatch();
  const sincEducObj = userInfo.companies.find((comps) => comps.companyId.name === 'Sincroniza Educação');
  const sincProjObj = userInfo.companies.find((comps) => comps.companyId.name === 'Sincroniza Projetos');
  const sincEduc = typeof sincEducObj !== 'undefined' ? sincEducObj.companyId.name : '';
  const sincProj = typeof sincProjObj !== 'undefined' ? sincProjObj.companyId.name : '';

  function handleClient(e) {
    let value = e.target.value;
    setCnpj(value[0]);
    value[0] === '1' && setClientAndProject(value.replace('1', ''));
    value[0] === '2' && setClientAndProject(value.replace('2', ''));
    setCompany(value[0] === '1' ? 'Sincroniza Educação' : 'Sincroniza Projetos');
  }

  useEffect(() => {
    dispatch(SearchClientsProjectsAction());
  }, [dispatch]);

  return (
    <SelectClient>
      <p>Cliente - Projeto - Empresa</p>
      <select name="selectClient" onChange={handleClient}>
        <option value="0">Selecione o Cliente - Projeto - Empresa</option>
        {searchClientsProjects &&
          searchClientsProjects.map((cpe, index) => {
            if (cpe.isActive) {
              if (sincEduc === cpe.company) {
                return (
                  <option key={index + 1} value={`${cpe.cnpj}${cpe.name}`}>
                    {cpe.name} ({cpe.company})
                  </option>
                );
              } else if (sincProj === cpe.company) {
                return (
                  <option key={index + 1} value={`${cpe.cnpj}${cpe.name}`}>
                    {cpe.name} ({cpe.company})
                  </option>
                );
              }
            }
            return 0;
          })}
        {searchClientsProjectsError && <option value="0"> Houve um erro, nenhum projeto encontrado </option>}
      </select>
    </SelectClient>
  );
}
